import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import "./assets/components/react-toastify.css";
import "./assets/components/styles.css";
import "./assets/components/cls-prevention.css";
import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
